(function (angular) {
    'use strict';

    angular
        .module('app.layout', ['ui.router', 'ui.bootstrap']);
        
}(angular));
